import { useMemo } from 'react';
import { DocsVerificationDocumentTypeEnum, DocsVerificationPhotosKeysEnum } from '@models/enums';
import { useAppSelector } from '@store';

export const useSelectedChecks = () => {
    const sdkOptions = useAppSelector((state) => state.docsVerification.sdkOptions);

    const isHasPassport = sdkOptions?.settings?.poi_allowed_documents?.includes(
        DocsVerificationDocumentTypeEnum.PASSPORT,
    );

    const isHasIdCard = sdkOptions?.settings?.poi_allowed_documents?.includes(
        DocsVerificationDocumentTypeEnum.ID_CARD,
    );

    const isHasVisa = sdkOptions?.settings?.poi_allowed_documents?.includes(
        DocsVerificationDocumentTypeEnum.VISA,
    );
    const isHasDriverLicense = sdkOptions?.settings?.poi_allowed_documents?.includes(
        DocsVerificationDocumentTypeEnum.DRIVER_LICENSE,
    );
    const isHasPoI = !!sdkOptions?.settings?.poi_required;
    const isHasLiveness = !!sdkOptions?.settings?.face_comparison_required;

    const isHasProofAddress = useMemo(
        () =>
            sdkOptions?.checks?.includes(DocsVerificationPhotosKeysEnum.POA) ||
            sdkOptions?.settings?.poa_required,
        [sdkOptions],
    );

    const isHasPersonalData = !!sdkOptions?.settings?.manual_fields_settings?.enabled;

    return {
        isHasPassport: !!isHasPassport,
        isHasIdCard: !!isHasIdCard,
        isHasVisa: !!isHasVisa,
        isHasDriverLicense: !!isHasDriverLicense,
        isHasLiveness,
        isHasProofAddress: !!isHasProofAddress,
        isHasPersonalData,
        isHasPoI,
    };
};
